// Axios and configuration
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import { I_ActionApproval } from "../interfaces";

// Utilities
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Sends an approval action (approve/deny/etc.) to the API.
 *
 * @param payload - Object containing all data required to perform the approval action
 * @returns A boolean indicating whether the request was successful
 */
const ActionApproval = async (payload: I_ActionApproval): Promise<boolean> => {
  try {
    const response = await Axios.post<I_BaseAPIResponse<string>>(
      `${process.env.REACT_APP_API_URL}/api/approval/action`,
      payload,
      AxiosConfig.configValue("min") // "min" config may indicate lighter headers or minimal auth
    );

    if (response.data.HasError) {
      snackBar({
        type: "error",
        text: response.data.ErrorMessage,
        timeout: 4000,
      });
      return false;
    }

    return true;
  } catch (error) {
    console.error("ActionApproval failed:", error);
    snackBar({
      type: "error",
      text: "Failed to action approval",
      timeout: 4000,
    });
    return false;
  }
};

export default ActionApproval;
